import {Component, Input, OnInit} from "@angular/core";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {Router} from "@angular/router";
declare var FB: any;

@Component({
    selector: 'db-manual-optimization-dialog',
    templateUrl: 'manual-optimization-dialog.component.html',
    styleUrls: ['manual-optimization-dialog.component.scss'],
    standalone: false
})
export class ManualOptimizationDialogComponent extends DialogComponent<null, boolean> implements OnInit {

  @Input() websiteId: number;

  constructor(
    private _router: Router,
    private _dialogService: DialogService,
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit(): void {

  }

}
